module.exports = __webpack_public_path__ + "static/media/unevenshoulder_severe_right.cf7bc8f3.png";